import React from "react";
import { Box, Button, Container } from "@mui/material";
import { QuoteStatus } from "../QuoteRequest/Content";
import { FooterButtonWrapper } from "./FooterStyled";

const FooterButtonsNotesApprovals = ({
  loggedInUser,
  quoteStatusId,
  pendingApproverRoles,
  createdBy,
  handleApproveClick,
  handleAddNote,
  handleReject,
  handleModify,
}) => {

  const roleId =
  loggedInUser.userRole[0]?.id;


  /*
  CORE RULE:
  Whoever approval is pending with
  can approve / modify / reject
  */

  const canApprove =
  pendingApproverRoles?.includes(roleId);


  return (

    <FooterButtonWrapper>

      <Container maxWidth="xl">

        <Box className="d-flex">


          {/* ADD NOTE */}

          <Box className="rightButton">

            <Button
              variant="contained"
              style={{ width: "110px" }}
              onClick={handleAddNote}
            >

              + Add Note

            </Button>

          </Box>



          {/* APPROVAL BUTTONS */}

          {canApprove && (

            <Box className="leftButtons">

              <div className="leftBtnOne">

                <Button
                  variant="contained"
                  style={{ width: "110px" }}
                  onClick={handleModify}
                  className="btnleftone"
                >

                  Modify

                </Button>

              </div>


              <div className="leftBtnTwo">

                <Button
                  variant="contained"
                  style={{ width: "110px" }}
                  onClick={handleApproveClick}
                >

                  Approve

                </Button>

              </div>


              <div className="leftBtnTwo">

                <Button
                  variant="contained"
                  style={{ width: "110px" }}
                  className="btnReject"
                  onClick={handleReject}
                >

                  Reject

                </Button>

              </div>

            </Box>

          )}



          {/* INITIAL REQUESTOR MODIFY */}

          {
          quoteStatusId ===
          QuoteStatus.QUOTEPENDINGINITIALREQUESTOR &&
          loggedInUser.user?.id === createdBy && (

          <Box className="leftButtons">

          <div className="leftBtnOne">

          <Button
          variant="contained"
          onClick={handleModify}
          className="btnleftone"
          >

          Modify

          </Button>

          </div>

          </Box>

          )
          }


        </Box>

      </Container>

    </FooterButtonWrapper>

  );

};

export default FooterButtonsNotesApprovals;